import { AssetUrlPipe } from "../../../core/pipes/asset-url.pipe";
import { Component, inject, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-solution-modal-component',
  standalone: true,
  imports: [AssetUrlPipe, ],
  templateUrl: './solution-modal-component.component.html',
  styleUrl: './solution-modal-component.component.scss'
})
export class SolutionModalComponentComponent {

  @Input() projectId: string | null = null;

  activeModal = inject(NgbActiveModal);
  private modalService = inject(NgbModal);

  selectedType: string | null = 'agentic';

  selectType(type: string) {
    this.selectedType = type;
  }

  confirm(){
    this.activeModal.close(this.selectedType);
  }
  
}
